"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var CountryImage = function CountryImage(_ref) {
  var imagePath = _ref.imagePath;
  return /*#__PURE__*/_react["default"].createElement(StyledCountryimage, {
    imagePath: imagePath
  });
};

exports.CountryImage = CountryImage;

var StyledCountryimage = _styledComponents["default"].div.withConfig({
  displayName: "CountryImage__StyledCountryimage",
  componentId: "sc-1soc75a-0"
})(["width:100%;height:50px;background-repeat:no-repeat;background-size:cover;background-position:center;background-image:url('", "');border-top-left-radius:", ";border-top-right-radius:", ";@media (min-width:1580px){height:100%;border-top-right-radius:0;border-bottom-left-radius:", ";}@media (min-width:1920px){max-width:250px;}"], function (_ref2) {
  var imagePath = _ref2.imagePath;
  return imagePath;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shape.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.shape.borderRadius;
});